export const stepperAction = (sceneSetting, currentStepLength, type, getPreviewStepLength ) => {
  if (type === "next") {
    if (sceneSetting.currentSubStep === currentStepLength - 1) {
      if (sceneSetting.currentStep < sceneSetting.stepTotal - 1) {
        if (!sceneSetting.completedStepList.includes(sceneSetting.currentStep)){
          sceneSetting.completedStep += 1;
          sceneSetting.completedStepList.push(sceneSetting.currentStep);
        }
        sceneSetting.currentStep += 1;
        sceneSetting.currentSubStep = 0;
      }
      if (
        sceneSetting.currentStep === sceneSetting.completedStep &&
        sceneSetting.currentStep === sceneSetting.stepTotal - 1
        ){
          sceneSetting.completedStep += 1;
          sceneSetting.completedStepList.push(sceneSetting.currentStep);
        }
        
    } else {
      sceneSetting.currentSubStep += 1;
    }
  } else {
    if (sceneSetting.currentSubStep === 0) {
      sceneSetting.currentStep -= 1;
      console.log(sceneSetting.currentStep)
      sceneSetting.currentSubStep = getPreviewStepLength - 1;
      console.log(getPreviewStepLength)
    } else {
      sceneSetting.currentSubStep -= 1 ;
      console.log(sceneSetting.currentStep)
      console.log(getPreviewStepLength)
    }
  }
  return sceneSetting
}

export const goToStep = (sceneSetting, stepId) => {

  sceneSetting.currentStep = stepId;
  sceneSetting.currentSubStep = 0;
  
  return sceneSetting
}